'use strict'

module.exports = () => {
  const services = {}

  const setterGetter = (newServices = undefined) => {
    if (newServices) {
      Object.assign(services, newServices)
    }

    return services
  }

  setterGetter.clear = () =>
    Object.keys(services).forEach(key => delete services[key])

  return setterGetter
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/service-container/services.js